import $ from 'jquery';

const object = orecaObject;

$('.filter__autocomplete')
    .autocomplete({
        minLength: 3,
        appendTo: '.filter__wrapper',
        source: function (request, response) {
            $.ajax({
                url: object.ajaxUrl,
                type: 'POST',
                dataType: 'JSON',
                data: {
                    nonce: object.nonce,
                    action: 'oreca_get_posts',
                    keyword: request.term,
                    postType: $('.filter').attr('data-post-type'),
                },
                success: function (res) {
                    response(res.data.data);
                },
            });
        },
        search: function (event) {
            $(event.target).parents('.filter').find('button[type=submit]').hide();
            $(event.target).parents('.filter').find('form .vn-loader').show();
        },
        open: function (event) {
            $(event.target).parents('.filter').find('button[type=submit]').show();
            $(event.target).parents('.filter').find('form .vn-loader').hide();
            $(event.target).addClass('autocomplete-active');
        },
        close: function (event) {
            $(event.target).removeClass('autocomplete-active');
        },
        create: function () {
            $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                return $('<li>')
                    .append(`<a href="${item.url}" class="res-class">${item.thumbnail ? `<img src="${item.thumbnail}" alt="${item.name}">` : ''}${item.title}</a>`)
                    .appendTo(ul);
            };
        },
    })
    .focus(function () {
        $(this).data('uiAutocomplete').search($(this).val());
    });

$('.filter').on('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
});